import { Box, Typography, useMediaQuery } from '@mui/material';
import CustomTitleWithBlueBackground from '../common/CustomTitleWithBlueBackground';
import PrimaryBlueButton from '../common/buttons/PrimaryBlueButton';
import { useNavigate } from 'react-router-dom';
import BorderedButton from '../common/buttons/BorderedButton';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

const GuestHome = ({ imageSrc }) => {
  const { theme } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        backgroundColor: theme.custom.pages.guest.home.backgroundColor,
        display: 'flex',
        marginTop: '32px',
        padding: {md: '40px'},
        borderRadius: '16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        [theme.breakpoints.down('md')]: {
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'center', md: 'flex-start' },
          gap: '32px',
          alignSelf: 'stretch',
          flexDirection: { xs: 'column', md: 'row' },
          width: '100%',
        }}
      >
        {/* Left Image Section */}
        <Box
          component="img"
          src={imageSrc}
          alt="Guest Home"
          sx={{
            alignItems: 'center',
            width: '360px',
            height: '432px',
            borderRadius: '16px',
          }}
        />

        {/* Right Text Section */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              color: theme.custom.pages.guest.home.typography.color,
              typography: { sm: 'h5', md: 'h3' },
              alignSelf: 'stretch',
              fontSize: '47px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '50px',
              letterSpacing: '-0.25px',
              marginBottom: '8px',
            }}
          >
            At-home PFAS and toxin testing
          </Typography>
          <Box
            sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'center', md: 'flex-start' }, width: '100%' }}
          >
            <CustomTitleWithBlueBackground
              parentSxProps={{
                alignItems: { xs: 'center', sm: 'center', md: 'flex-start' },
              }}
              text={
                isMobile
                  ? 'Helping everyone live healthier\nlives in the face of toxin exposure'
                  : 'Helping everyone live healthier\nlives in the face of toxin\nexposure'
              }
            />
          </Box>
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              color: theme.custom.pages.guest.home.typography.color,
              fontSize: '28px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '36px',
              marginTop: '32px',
            }}
          >
            Minimally invasive PFAS tests
          </Typography>
          <Typography
            sx={{
              color: theme.custom.pages.guest.home.typography.color,
              mt: 0.5,
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '20px',
              letterSpacing: '0.25px',
              marginBottom: '32px',
            }}
          >
            Our PFAS test is designed to be reliable and convenient. The test can be taken in the comfort of your home,
            with results available in our app within days. Results are added to a timeline so you can track your
            exposure over time.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: '16px',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: { xs: 'center', md: 'flex-start' },
              maxWidth: { xs: '100%', sm: 'auto' },
              padding: { xs: '0 24px', sm: '0' },
              width: { xs: '100%', sm: '40%', md: '100%' },
              margin: { xs: '0', sm: '0 auto', md: '0' },
            }}
          >
            <PrimaryBlueButton
              sxProps={{
                display: 'flex',
                padding: '10px 24px 10px 16px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                width: { xs: '100%', md: '160px' },

              }}
              additionalProps={{
                style: { borderRadius: '100px', height: '48px' },
                startIcon: (
                  <img
                    src={'/icons/shopping_cart_white.svg'}
                    alt={'Order test'}
                    style={{ width: '18px', height: '18px' }}
                  />
                ),
                href: process.env.REACT_APP_PRODUCT_PAGE_URL,
                target: '_blank'
              }}
              buttonText={'Order test'}
            />
            <BorderedButton
              sxProps={{
                display: 'flex',
                padding: '10px 24px 10px 16px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                width: { xs: '100%', md: '170px' },
                '& .MuiButton-startIcon': {
                  height: '18px',
                  width: '18px',
                  backgroundImage: `url(${theme.images.activateKitIcon.default})`,
                },
                '&:hover': {
                  background: 'transparent',
                  color: theme.buttons.ghost.hover.color,
                  border: '2px solid',
                  '& .MuiButton-startIcon': {
                    height: '18px',
                    width: '18px',
                    backgroundImage: `url(${theme.images.activateKitIcon.hover})`,
                  },
                },
                marginBottom: { xs: '18px', sm: '0px' },
              }}
              additionalProps={{
                style: { borderRadius: '100px', height: '48px' },
                // Needed so the icon styles work as expected
                startIcon: (<></>),
              }}
              onClick={() => navigate('/activate.html')}
              buttonText="Activate test"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default GuestHome;
